// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Wh_o","content":"styles_content__A7tYt","selectAll":"styles_selectAll__3S7Au"};